module.exports = "<a href=\"#\" routerLink=\"/add-client\" class=\"btn btn-success btn-block\"><span class=\"fa fa-plus\"></span> New</a>\n"


//////////////////
// WEBPACK FOOTER
// C:/clientpanel/src/app/components/sidebar/sidebar.component.html
// module id = ../../../../../src/app/components/sidebar/sidebar.component.html
// module chunks = main